module.exports = __webpack_public_path__ + "images/4.1788773129009.jpg";